import WeatherRoutingVoyageService from "../../services/voyage/service";
import createVoyageDataToJson from "../../domain/weather_routing/create_voyage/mapper_to_json";
import calculationStateDataFromJson from "../../domain/weather_routing/calculation_state/mapper";
import voyageDataFromJson from "../../domain/weather_routing/voyage/db/mapper";
import HttpError from "../../services/http_error";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;
const companyId = process.env.VUE_APP_COMPANY_ID;

const voyageService = new WeatherRoutingVoyageService(
  localWeatherRoutingServerUrl,
  companyId,
  createVoyageDataToJson,
  voyageDataFromJson,
  calculationStateDataFromJson
);

const getDefaultState = () => {
  return {
    allVoyages: null,
    filteredVoyages: null,
    fetchLoading: true,
    fetchError: null,
    deleteLoading: false,
    deleteError: null,

    currentOffset: 0,
    paginatedFetchLoading: false,
    paginatedFetchError: null,
  };
};

const state = getDefaultState();

const getters = {
  // eslint-disable-next-line eqeqeq
  requestFailed: (state) => (state.fetchError != null),
  // eslint-disable-next-line eqeqeq
  noVoyages: (state) => (state.filteredRoutes != null && state.filteredRoutes.length === 0),
};

const actions = {

  async fetchAllVoyages({ commit, rootState }) {
    commit("SET_FETCH_LOADING_STATE");
    const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
    try {
      const voyages = await voyageService.getMany(
        localStorage.getItem("quad_token"),
        accessToken,
      );
      commit("SET_FETCH_SUCCESS_STATE", voyages);
    }
    catch (e) {
      if (e instanceof HttpError) {
        return;
      }
      commit("SET_FETCH_FAILED_STATE");
    }
  },

  async paginatedFetchAllVoyages({ commit, rootState }) {
    commit("SET_PAGINATED_FETCH_LOADING_STATE");
    try {
      const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
      const voyages = await voyageService.getMany(
        localStorage.getItem("quad_token"),
        accessToken,
        state.currentOffset
      );
      commit("SET_PAGINATED_FETCH_SUCCESS_STATE", voyages);
    }
    catch (e) {
      if (e instanceof HttpError) {
        commit("SET_PAGINATED_FETCH_FAILED_STATE");
        return;
      }
      commit("SET_PAGINATED_FETCH_FAILED_STATE");
    }
  },

  async deleteVoyage({ dispatch, rootState }, payload) {
    const voyageId = payload.voyageId;
    const voyageTheyrId = payload.theyrId;
    const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
    try {
      await voyageService.delete(localStorage.getItem("quad_token"), accessToken, voyageId, voyageTheyrId);
      await dispatch("fetchAllVoyages");
    } catch (e) {
      if (e instanceof HttpError) {
        // here you handle a specific case and commit the according
        // error message
        return;
      }
    }
  },

  filterVoyagesByDescription({ state, commit }, payload) {
    const description = payload.description;
    if (description !== "") {
      const filteredVoyages = state.allVoyages.filter((voyage) => voyage.description.includes(description));
      commit("SET_FILTERED_VOYAGES", filteredVoyages);
    }
    else {
      commit("SET_FILTERED_VOYAGES", state.allVoyages);
    }
  }

};

const mutations = {
  SET_ALL_VOYAGES: (state, data) => (state.allVoyages = data),
  SET_FILTERED_VOYAGES: (state, data) => (state.filteredVoyages = data),
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },

  SET_FETCH_FAILED_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch routes";
  },
  SET_FETCH_SUCCESS_STATE(state, data) {
    state.fetchLoading = false;
    state.fetchError = null;
    state.allVoyages = data;
    state.filteredVoyages = data;
  },
  SET_PAGINATED_FETCH_LOADING_STATE(state) {
    state.currentOffset += 1;
    state.paginatedFetchLoading = true;
    state.paginatedFetchError = null;
  },
  SET_PAGINATED_FETCH_FAILED_STATE(state, error) {
    state.paginatedFetchLoading = false;
    state.paginatedFetchError = error;
    state.currentOffset -= 1;
  },
  SET_PAGINATED_FETCH_SUCCESS_STATE(state, data) {
    if (data.length > 0) {
      state.paginatedFetchLoading = false;
      state.paginatedFetchError = null;
      state.allVoyages = [...state.allVoyages, ...data];
      state.filteredVoyages = [...state.filteredVoyages, ...data];
    }
    else {
      state.currentOffset -= 1;
    }
  },
  SET_DELETE_LOADING_STATE(state) {
    state.deleteLoading = true,
    state.deleteError = null;
  },
  SET_DELETE_FAILED_STATE(state) {
    state.deleteLoading = false,
    state.deleteError = "Deletion failed";
  },
  SET_DELETE_SUCCESS_STATE(state) {
    state.deleteLoading = false,
    state.deleteError = null;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export const weatherRoutingVoyagesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
